import { useQuery } from '@tanstack/react-query'

import { belongInstance } from '@/modules/belongs'

import { usePatientContext } from '../contexts/PatientContext'

export function useBelongItemsQuery() {
  const { patient } = usePatientContext()
  return useQuery({
    queryKey: ['belongItems', patient],
    queryFn: async () => await belongInstance.getItemsList(patient!.id),
    enabled: !!patient?.id,
    initialData: []
  })
}
